<template>
  <div v-if="plate">
    <v-checkbox
      :label="`${lead.firstname}, The Rates are based on your age, health and
        life style, so I'll briefly ask a few questions`"
      v-model="plate.isQuestionsAsked"
      :error="$v.plate.isQuestionsAsked.$error"
    />

    <v-checkbox
      :label="`Again my name is ${agent.fname} ${agent.lname},
      feel free to interrupt me if you have any questions`"
      v-model="plate.isAgentConfirm"
      :error="$v.plate.isAgentConfirm.$error"
    />

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps } from '@/common/variables';
import { isChecked } from '@/common/helpers';

export default {
  name: 'ProcessPlate',
  components: { PlateFooter },
  props: {
    lead: {
      type: Object,
    },
    agent: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({ branch: 'plates/branch' }),
    backPlate() {
      return this.branch ? PlatesSteps.disabledNeeds : PlatesSteps.needs;
    },
  },
  data: () => ({
    plate: null,
    isLoading: false,
  }),
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.process
    );
    this.plate = data;
  },
  methods: {
    onBack() {
      this.$store.commit('plates/setStep', this.backPlate);
    },

    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setStep', PlatesSteps.basicInfo);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
  validations: {
    plate: {
      isQuestionsAsked: {
        checked: isChecked,
      },
      isAgentConfirm: {
        checked: isChecked,
      },
    },
  },
};
</script>

<style scoped></style>